import { Checkbox as AntCheckbox, CheckboxProps } from "antd";
import styled from "styled-components";

export const Checkbox: typeof AntCheckbox = styled(
  AntCheckbox
)<CheckboxProps>``;
